import { render, staticRenderFns } from "./events-dow-cards.vue?vue&type=template&id=133106c6&"
import script from "./events-dow-cards.vue?vue&type=script&lang=js&"
export * from "./events-dow-cards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports